import * as angular from "angular";
import {IController, IRootScopeService} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {PolygonService} from "../../services/polygons-service.service";
import {ServiceAreaRequests} from "../../services/service-area-requests.service";
import {ServiceAreasAlerts} from "../../services/service-areas-alerts.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {AccountModel} from "../../../account/angular/models/account.model";
import {DepotModel} from "../../../depots/angular/models/depot.model";
import {AccountsService} from "../../../account/services/accounts-service.service";
import {ServiceAreasService} from "../../services/service-areas-service.service";
import {GeofenceZonesService} from "../../services/geofence-zones-service.service";
import {GeofenceLocationType, GeofenceZone, GeofenceZonesQueryParams} from "../../models/geofence-zone.model";
import {IAMPermissionsService} from "../../../../permission/iamPermissions.service";
import {AreaFeatureCollectionModel} from "../../models/service-areas-feature-collection.model";

interface ZoneTabState {
  locationType: GeofenceLocationType;
  zones: GeofenceZone[];
  byId: { [id: string]: AccountModel | DepotModel };
  featureCollection: any;
  searchQuery: string;
  cursor: string;
  loading: boolean;
  excludedIds: string[];
}

export class serviceAreasViewCtrl implements IController {

  featureCollection: any;

  private serviceAreaRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private siteId: any;

  private searchQuery: any;
  private selectedFeature: any;
  private editingFeature: any;
  private loading: any;
  private mapReady: any;
  private branchIds: string[];
  private tags: string[];
  private types: any;
  public selectedTab: string;
  public editingServiceArea;
  public editingCoordinatesRing: any;

  private depotsRef: any;
  public accounts: AccountModel[];
  public depots: DepotModel[];

  public zoneTabs: { [type: string]: ZoneTabState };
  public currentZoneTab: ZoneTabState;
  private static readonly ZONES_PAGE_SIZE = 50;
  private static readonly GEOFENCE_ZONES_LIST_PERMISSION = 'geofence.zones.list';

  /* @ngInject */
  constructor(private $serviceArea, private serviceAreasAlerts: ServiceAreasAlerts, private $log, private polygonService: PolygonService,
              private bringozLoaderService: BringozLoaderService, private $rootScope: IRootScopeService, private serviceAreaRequests: ServiceAreaRequests, private confirmDialogService: ConfirmDialogService,
              private splitService: SplitService, private $depots, private accountsService: AccountsService, private IAMPermissions: IAMPermissionsService,
              private serviceAreasService: ServiceAreasService, private geofenceZonesService: GeofenceZonesService, private $infiniteScroll) {
    this.depotsRef = this.$depots();
  }

  $onInit() {
    this.siteId = this.splitService.getSiteId();

    this.searchQuery = undefined;
    this.selectedFeature = undefined;
    this.editingServiceArea = undefined;
    this.editingFeature = undefined;
    this.selectedFeature = undefined;
    this.loading = false;
    this.mapReady = false;
    this.branchIds = [];
    this.tags = [];
    this.types = [];
    this.selectedTab = 'serviceArea';

    this.zoneTabs = {
      [GeofenceLocationType.ACCOUNT]: this._createZoneTabState(GeofenceLocationType.ACCOUNT),
      [GeofenceLocationType.DEPOT]: this._createZoneTabState(GeofenceLocationType.DEPOT)
    };
    this.currentZoneTab = undefined;

    if (this.IAMPermissions.hasPermission('accounts.demand.list')) {
      this._getAccounts();
    }
    if (this.IAMPermissions.hasPermission('depots.list')) {
      this._getDepots();
    }

    this.serviceAreaRef = this.$serviceArea();
    this.loadLimit = 30;

    this.serviceAreaRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.serviceAreaRef, this.loadLimit, {getFullData: true});


    this._getServiceAreaFeatureCollection();
  }

  private _createZoneTabState(locationType: GeofenceLocationType): ZoneTabState {
    return {
      locationType: locationType,
      zones: [],
      byId: {},
      featureCollection: {type: 'FeatureCollection', features: []},
      searchQuery: undefined,
      cursor: undefined,
      loading: false,
      excludedIds: []
    };
  }

  onSearchQueryChange(query) {
    this.searchQuery = query;
    this._getServiceAreaFeatureCollection();
    this._reload();
  }

  onBranchesChange(branchIds) {
    this.branchIds = branchIds;

    this._getServiceAreaFeatureCollection();
    this._reload();
  }

  onTagsChange(tags) {
    this.tags = tags;
    this._getServiceAreaFeatureCollection();
    this._reload();
  }

  onTypesChange(types) {
    this.types = types;
    this._getServiceAreaFeatureCollection();
    this._reload();
  }

  onSelectFeature(serviceArea, doScroll) {
    const areaId = serviceArea?.id || serviceArea?.properties?.id || serviceArea?.properties?.areaId;
    const selectedId = this.selectedFeature?.properties?.id || this.selectedFeature?.properties?.areaId || this.selectedFeature?.id;
    const features = this.currentZoneTab
      ? _.get(this.currentZoneTab, 'featureCollection.features', [])
      : _.get(this.featureCollection, 'features', []);
    this.selectedFeature = (selectedId === areaId) ?
      undefined :
      _.find(features, (feature) => {
        return feature.properties.id === areaId || feature.properties.areaId === areaId;
      });
    if (doScroll && areaId) {
      this._anchorScroll(areaId);
    }
  }

  onCreateFeature() {
    this.editingServiceArea = {
      // serviceTypes: ServiceAreaConstants.serviceTypes
    }
    this.editingFeature = this.polygonService.getEmptyFeature();
    this.editingCoordinatesRing = undefined;
  }

  onChangeCoordinates(coordinates) {
    this.editingCoordinatesRing = coordinates || undefined;
    if (!this.editingFeature) {
      return;
    }
    this.editingFeature.geometry.coordinates = coordinates ? [coordinates] : undefined;
  }

  onChangeEditingFeature(updatedFeature) {
    const previousRing = _.get(this.editingFeature, 'geometry.coordinates[0]');
    const nextRing = _.get(updatedFeature, 'geometry.coordinates[0]');
    this.editingFeature = updatedFeature;
    if (!_.isEqual(previousRing, nextRing)) {
      this.editingCoordinatesRing = undefined;
    }
  }

  onChangeEditingServiceArea(serviceArea) {
    this.editingServiceArea = serviceArea;
  }

  onCancelCreatingFeature() {
    this.editingServiceArea = undefined;
    this.editingFeature = undefined;
    this.editingCoordinatesRing = undefined;
  }

  onEditFeature(serviceArea, event) {
    this.editingServiceArea = serviceArea;
    this.editingCoordinatesRing = undefined;
    const serviceAreaId = serviceArea?.id || serviceArea?.areaId;
    const feature = _.find(this.featureCollection.features, (f) => {
      const featureId = f.properties.areaId || f.properties.id;
      return featureId === serviceAreaId;
    });
    this.editingFeature = feature ? angular.copy(feature) : undefined;
  }

  onDeleteFeature(serviceArea, event) {
    const text = 'Are you sure you want to delete this service area?';
    this.confirmDialogService.confirm('Delete Service Area', text, event)
      .then(() => {
        this._deleteFeature(serviceArea);
      })
      .catch((err) => {
        this.$log.info('Dialog Closed');
      })
  }

  _deleteFeature(serviceArea) {
    const areaId = _.get(serviceArea, 'id');
    this.bringozLoaderService.on();
    this.serviceAreaRequests.deleteOne(areaId)
      .then(() => {
        this.featureCollection.features = _.filter(this.featureCollection.features, (f) => {
          return !_.isEqual(areaId, _.get(f, 'properties.areaId'));
        })
        this._reload();
        this.serviceAreasAlerts.removeSuccess();
      })
      .catch((error) => {
        this.serviceAreasAlerts.removeError();
        this.$log.error('Failed to delete service area @serviceAreasView@_deleteFeature', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  onCancelEditingFeature() {
    this.editingServiceArea = undefined;
    this.editingFeature = undefined;
    this.editingCoordinatesRing = undefined;
  }

  onSaveEditingFeature(feature, serviceArea, doRePrice) {
    const featureForSave = angular.copy(feature);
    if (this.editingCoordinatesRing?.length) {
      featureForSave.geometry = featureForSave.geometry || {type: 'Polygon'};
      featureForSave.geometry.coordinates = [this.editingCoordinatesRing];
    }
    if (serviceArea?.color) {
      featureForSave.properties.fill = serviceArea.color;
      featureForSave.properties.stroke = serviceArea.color;
    }
    const featureToUpdate = this.polygonService.getRevertedFeature(featureForSave);
    const serviceAreaToUpdate = {
      ...featureToUpdate,
      ...serviceArea,
      coordinates: featureToUpdate.coordinates,
      areaId: featureToUpdate.areaId || serviceArea.areaId || serviceArea.id
    };
    if (serviceAreaToUpdate.areaId || serviceAreaToUpdate.id) {
      this._updateExistingServiceArea(serviceAreaToUpdate, doRePrice)
    } else {
      this._createNewServiceArea(serviceAreaToUpdate);
    }
  }

  onMapReady() {
    this.mapReady = true;
  }

  onSelectTab(tab: string) {
    if ((tab === 'ACCOUNT' || tab === 'DEPOT') && !this.IAMPermissions.hasPermission(serviceAreasViewCtrl.GEOFENCE_ZONES_LIST_PERMISSION)) {
      return;
    }

    this.selectedTab = tab;
    this.editingServiceArea = undefined;
    this.editingFeature = undefined;
    this.selectedFeature = undefined;
    this.currentZoneTab = this.zoneTabs[tab];

    if (tab === 'ACCOUNT') {
      this._getZones(GeofenceLocationType.ACCOUNT);
    }
    if (tab === 'DEPOT') {
      this._getZones(GeofenceLocationType.DEPOT);
    }
  }

  // ******************************
  //        Geofence zones
  // ******************************

  onZoneSearchQueryChange(locationType: GeofenceLocationType, query: string) {
    const tab = this.zoneTabs[locationType];
    if (tab) {
      tab.searchQuery = query;
    }
  }

  onCreateZoneFeature(locationType: GeofenceLocationType) {
    this.editingFeature = this.polygonService.getEmptyGeofenceZoneFeature(locationType);
  }

  onEditZoneFeature(feature) {
    this.editingFeature = angular.copy(feature);
  }

  onDeleteZoneFeature(feature, event) {
    const locationType: GeofenceLocationType = _.get(feature, 'properties.locationType');
    const isAccount = locationType === GeofenceLocationType.ACCOUNT;
    const title = isAccount ? 'Delete Account Geofence' : 'Delete Depot Geofence';
    const text = isAccount
      ? 'Are you sure you want to delete this account geofence?'
      : 'Are you sure you want to delete this depot geofence?';
    this.confirmDialogService.confirm(title, text, event)
      .then(() => {
        this._deleteZoneFeature(feature);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      });
  }

  onSaveZoneFeature(feature) {
    const zone: GeofenceZone = this.polygonService.getRevertedGeofenceZoneFromFeature(feature);
    if (zone.id) {
      this._updateExistingZone(zone);
    } else {
      this._createNewZone(zone);
    }
  }

  onLoadMoreZones(locationType: GeofenceLocationType) {
    if (!this.IAMPermissions.hasPermission(serviceAreasViewCtrl.GEOFENCE_ZONES_LIST_PERMISSION)) {
      return;
    }
    const tab = this.zoneTabs[locationType];
    if (!tab || !tab.cursor) {
      return;
    }
    this._getZones(locationType, tab.cursor);
  }

  onExportServiceAreaGeoJson(id) {
    if (!id) {
      return;
    }
    this.serviceAreasService.exportGeoJson({ids: [id]});
  }

  onExportServiceAreaKml(id) {
    if (!id) {
      return;
    }
    this.serviceAreasService.exportKml({ids: [id]});
  }

  // ******************************
  //        Private methods
  // ******************************

  _updateExistingServiceArea(featureToUpdate, doRePrice) {
    this.loading = true;
    const savedColor = featureToUpdate.color;
    this.$serviceArea(featureToUpdate.areaId).$update(featureToUpdate, {}, {rePrice: doRePrice})
      .then((updatedServiceArea) => {
        const areaForMap = {
          ...updatedServiceArea,
          color: updatedServiceArea.color || savedColor,
        };
        this._replaceServiceAreaFeature(areaForMap);
        this.infiniteScroll.updateItems([areaForMap]);
        this.serviceAreasAlerts.updateSuccess();
        this.editingServiceArea = undefined;
        this.editingCoordinatesRing = undefined;
        // null = saved — do not restore the pre-edit polygon snapshot on the map
        this.editingFeature = null;
      })
      .catch((error) => {
        this.serviceAreasAlerts.updateError();
        this.$log.error('Failed to update service area @serviceAreasView@onSaveEditingFeature', error);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  _createNewServiceArea(featureToSave) {
    this.loading = true;
    this.serviceAreaRequests.createNewServiceArea(featureToSave)
      .then((createdServiceArea) => {
        this._replaceServiceAreaFeature(createdServiceArea, true);
        this.infiniteScroll.addItems([createdServiceArea]);
        this.serviceAreasAlerts.createSuccess();
        this.editingServiceArea = undefined;
        this.editingCoordinatesRing = undefined;
        this.editingFeature = null;
      })
      .catch((error) => {
        this.serviceAreasAlerts.createError();
        this.$log.error('Failed to create service area @serviceAreasView@_createNewServiceArea', error);
      })
      .finally(() => {
        this.loading = false;
      })
  }

  private _replaceServiceAreaFeature(serviceArea, isNew = false) {
    const areaId = serviceArea.areaId || serviceArea.id;
    const updatedFeature = this.polygonService.getFeatures([serviceArea])[0];
    const features = (this.featureCollection?.features || []).slice();

    if (isNew) {
      features.push(updatedFeature);
    } else {
      const featureIndex = _.findIndex(features, (feature: any) => {
        const id = feature.properties.areaId || feature.properties.id;
        return id === areaId;
      });
      if (featureIndex === -1) {
        features.push(updatedFeature);
      } else {
        features[featureIndex] = updatedFeature;
      }
    }

    this.featureCollection = {
      type: 'FeatureCollection',
      features: features
    };
  }

  _anchorScroll(id) {
    this.$rootScope.$broadcast('anchor-scroll', id);
  }

  private _getAccounts() {
    const query = {
      isDemand: true,
      isActive: true
    }
    this.accountsService.getAll(query)
      .then(accounts => {
        this.accounts = accounts;
        const tab = this.zoneTabs[GeofenceLocationType.ACCOUNT];
        tab.byId = _.keyBy(accounts, 'id');
        this._refreshZoneFeatureCollection(GeofenceLocationType.ACCOUNT);
      });
  }

  private _getDepots() {
    this.depotsRef.$getAll()
      .then((ids) => {
        return this.depotsRef.$asyncValues(ids);
      })
      .then((depots) => {
        this.depots = depots;
        const tab = this.zoneTabs[GeofenceLocationType.DEPOT];
        tab.byId = _.keyBy(depots, 'id');
        this._refreshZoneFeatureCollection(GeofenceLocationType.DEPOT);
      })
      .catch((error) => {
        this.$log.error('Fail to $getAll', error);
      });
  }

  private _getZones(locationType: GeofenceLocationType, cursor?: string) {
    if (!this.IAMPermissions.hasPermission(serviceAreasViewCtrl.GEOFENCE_ZONES_LIST_PERMISSION)) {
      return;
    }
    const tab = this.zoneTabs[locationType];
    if (!tab || tab.loading) {
      return;
    }
    tab.loading = true;

    const params: GeofenceZonesQueryParams = {
      locationTypes: [locationType],
      limit: serviceAreasViewCtrl.ZONES_PAGE_SIZE
    };
    if (cursor) {
      params.cursor = cursor;
    } else {
      tab.zones = [];
    }

    this.geofenceZonesService.getAll(params)
      .then((page) => {
        const incoming = page.list || [];
        tab.zones = _.uniqBy(tab.zones.concat(incoming), 'id');
        tab.cursor = page.cursor;
        this._refreshZoneFeatureCollection(locationType);
      })
      .catch((error) => {
        this.$log.error(`Failed to load ${locationType} geofence zones @serviceAreasView@_getZones`, error);
      })
      .finally(() => {
        tab.loading = false;
      });
  }

  private _refreshZoneFeatureCollection(locationType: GeofenceLocationType) {
    const tab = this.zoneTabs[locationType];
    if (!tab) {
      return;
    }
    tab.featureCollection = this.polygonService.getGeofenceZoneFeatureCollection(tab.zones, tab.byId);
    tab.excludedIds = _.map(tab.zones, (z) => z.locationId);
  }

  private _createNewZone(zone: GeofenceZone) {
    const tab = this.zoneTabs[zone.locationType];
    if (!tab) {
      return;
    }
    this.loading = true;
    this.geofenceZonesService.create(zone.locationType, zone.locationId, zone)
      .then((created) => {
        tab.zones = tab.zones.concat([created]);
        this._refreshZoneFeatureCollection(zone.locationType);
      })
      .catch((error) => {
        this.$log.error(`Failed to create ${zone.locationType} geofence zone @serviceAreasView@_createNewZone`, error);
      })
      .finally(() => {
        this.editingServiceArea = undefined;
        this.editingFeature = undefined;
        this.loading = false;
      });
  }

  private _updateExistingZone(zone: GeofenceZone) {
    const tab = this.zoneTabs[zone.locationType];
    if (!tab) {
      return;
    }
    this.loading = true;
    this.geofenceZonesService.update(zone.id, zone)
      .then((updated) => {
        const index = _.findIndex(tab.zones, (z) => z.id === updated.id);
        if (index !== -1) {
          tab.zones[index] = updated;
          tab.zones = tab.zones.concat([]);
        }
        this._refreshZoneFeatureCollection(zone.locationType);
      })
      .catch((error) => {
        this.$log.error(`Failed to update ${zone.locationType} geofence zone @serviceAreasView@_updateExistingZone`, error);
      })
      .finally(() => {
        this.editingServiceArea = undefined;
        this.editingFeature = undefined;
        this.loading = false;
      });
  }

  private _deleteZoneFeature(feature) {
    const zoneId = _.get(feature, 'properties.areaId');
    const locationType: GeofenceLocationType = _.get(feature, 'properties.locationType');
    const tab = this.zoneTabs[locationType];
    if (!tab) {
      return;
    }
    this.geofenceZonesService.deleteOne(zoneId)
      .then(() => {
        tab.zones = _.filter(tab.zones, (z) => z.id !== zoneId);
        this._refreshZoneFeatureCollection(locationType);
      })
      .catch((error) => {
        this.$log.error(`Failed to delete ${locationType} geofence zone @serviceAreasView@_deleteZoneFeature`, error);
      });
  }

  private _getServiceAreaFeatureCollection() {
    const payload = {
      query: this.searchQuery,
      branchIds: this.branchIds,
      tags: this.tags,
      serviceTypes: this.types
    }

    this.serviceAreasService.getGeoJson(payload)
      .then((geoJsonFeatureCollection: AreaFeatureCollectionModel) => {
        this.featureCollection = geoJsonFeatureCollection;
      });
  }

  private _reload() {
    this.serviceAreaRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      query: this.searchQuery,
      branchIds: this.branchIds,
      serviceTypes: this.types,
      isCompact: true,
      tags: this.tags,
      sort: 'areaName,asc'
    };
  }

}

angular
  .module('bringoz.admin.service-areas')
  .component('serviceAreasView', {
    bindings: {
      featureCollection: '<'
    },
    template: require('./service-areas-view.html').default,
    controller: serviceAreasViewCtrl
  });
